import {
  AI_CONSENT_PROMPT_ENABLED,
  AI_VEHICLE_REVIEW_ENABLED,
  AI_VEHICLE_SUGGESTION_ENABLED,
  ALLOWED_LATEST_DOSSIER_REDIRECT_ROUTES,
  AP_DEFAULT_VEHICLE_DEALER_PROCUREMENT_FEE,
  AP_EV_HOME_CHARGING_RATE,
  AP_EXTERNAL_CLIENT_URL,
  AP_QUOTE_HIDE_INVALID_CALCULATIONS_ENABLED,
  ConfigurationMap,
  CRM_CLIENT_URL,
  FF_DRIVER_PORTAL_ENABLED,
  FF_EMPLOYER_PAYROLL_TAX_SAVINGS,
  OCR_EXPENSE_CLAIM_RECEIPT_ENABLED,
  PAYROLL_TAX_SAVINGS_DISPLAY_THRESHOLD,
  VEHICLE_SEARCH_ENABLED,
} from "../types/Config";
import { DossierStatusGroup } from "../types/Dossier";
import { isTrue } from "./string";

export const isAIVehicleSuggestionEnabled = (configMap: ConfigurationMap) => {
  const config = configMap[AI_VEHICLE_SUGGESTION_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const isAIVehicleReviewEnabled = (configMap: ConfigurationMap) => {
  const config = configMap[AI_VEHICLE_REVIEW_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const isAIConsentPromptEnabled = (configMap: ConfigurationMap) => {
  const config = configMap[AI_CONSENT_PROMPT_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const isVehicleSearchEnabled = (configMap: ConfigurationMap) => {
  const config = configMap[VEHICLE_SEARCH_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const isAPQuoteHideInvalidCalculationsEnabled = (
  configMap: ConfigurationMap
) => {
  const config = configMap[AP_QUOTE_HIDE_INVALID_CALCULATIONS_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const isOCRExpenseClaimReceiptEnabled = (
  configMap: ConfigurationMap
) => {
  const config = configMap[OCR_EXPENSE_CLAIM_RECEIPT_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const getEVHomeChargingRate = (configMap: ConfigurationMap) => {
  const config = configMap[AP_EV_HOME_CHARGING_RATE];
  return config?.value ? parseFloat(config.value) : 0.042;
};

export const getDefaultVehicleDealerProcurementFee = (
  configMap: ConfigurationMap
) => {
  const config = configMap[AP_DEFAULT_VEHICLE_DEALER_PROCUREMENT_FEE];
  return config?.value ? parseFloat(config.value) : 500;
};

export const getPayrollTaxSavingsDisplayThreshold = (
  configMap: ConfigurationMap
) => {
  const config = configMap[PAYROLL_TAX_SAVINGS_DISPLAY_THRESHOLD];
  return config?.value ? parseFloat(config.value) : 1000;
};

export const getAPExternalClientURL = (configMap: ConfigurationMap) => {
  const config = configMap[AP_EXTERNAL_CLIENT_URL];

  return config?.value ?? "https://auto-pilot.auto-ux.io";
};

export const getCRMClientURL = (configMap: ConfigurationMap) => {
  const config = configMap[CRM_CLIENT_URL];

  return (
    config?.value ??
    "https://auto-ux.crm6.dynamics.com/main.aspx?appid=17443cfb-ff51-ee11-be6f-002248933228"
  );
};

export const isFFDriverPortalEnabled = (configMap: ConfigurationMap) => {
  const config = configMap[FF_DRIVER_PORTAL_ENABLED];

  return config?.value ? isTrue(config.value) : false;
};

export const isFFEmployerPayrollTaxSavingsEnabled = (
  configMap: ConfigurationMap
) => {
  const config = configMap[FF_EMPLOYER_PAYROLL_TAX_SAVINGS];

  return config?.value ? isTrue(config.value) : false;
};

export const shouldShowPayrollTaxSavings = (
  configMap: ConfigurationMap,
  totalPayrollTaxSavings: number
) => {
  return (
    isFFEmployerPayrollTaxSavingsEnabled(configMap) &&
    totalPayrollTaxSavings >= getPayrollTaxSavingsDisplayThreshold(configMap)
  );
};

export const isAllowedLatestDossierRedirectRoute = (
  route: string,
  status: DossierStatusGroup,
  configMap: ConfigurationMap
) => {
  const allowedDestinations = configMap
    ? parseMapFromConfig(ALLOWED_LATEST_DOSSIER_REDIRECT_ROUTES, configMap)
    : null;
  const isAllRoute = allowedDestinations?.all?.includes(route) ?? false;
  const isStatusRoute = allowedDestinations?.[status]?.includes(route) ?? false;

  return isAllRoute || isStatusRoute;
};

export const parseMapFromConfig = (
  key: string,
  configMap: ConfigurationMap
): Record<string, string[]> | null => {
  const config = configMap[key];

  return config?.value ? JSON.parse(config.value) : null;
};
